<template>
  <div>
    <only-site-card :com_data="com_data">
      <template v-slot:item_edit>
        <ValidationObserver ref="observer">
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="2">
                <span class="font-weight-bold">セラピストからのコメント</span>
                <p class="red--text mini">
                  未入力の場合、コメントタブの「<strong>セラピストコメント</strong>」の内容で更新します。
                </p>
              </v-col>
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.comment_1.text"
                      :rules="items.comment_1.rules"
                    >
                      <v-textarea
                        ref="comment_1"
                        v-model="cast_prop.comment_1"
                        name="comment_1"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.comment_1.text"
                        :placeholder="`セラピストからのコメント`"
                        rows="6"
                        outlined
                        :counter="items.comment_1.counter"
                        background-color="white"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-8"></v-divider>
            <v-row>
              <v-col cols="12" sm="2">
                <span class="font-weight-bold">お店からのコメント</span>
                <p class="red--text mini">
                  未入力の場合、コメントタブの「<strong>お店コメント</strong>」の内容で更新します。
                </p>
              </v-col>
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.comment_2.text"
                      :rules="items.comment_2.rules"
                    >
                      <v-textarea
                        ref="comment_2"
                        v-model="cast_prop.comment_2"
                        name="comment_2"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.comment_2.text"
                        :placeholder="`お店からのコメント`"
                        rows="6"
                        outlined
                        :counter="items.comment_2.counter"
                        background-color="white"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-8"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">エステ歴</span></v-col
              >
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="6" sm="4" md="3">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.career.text"
                      :rules="items.career.rules"
                    >
                      <v-text-field
                        ref="career"
                        v-model="cast_prop.career"
                        name="career"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.career.text"
                        hint="数字2文字以内で入力して下さい。（単位：年）"
                        persistent-hint
                        suffix="年"
                        outlined
                        :maxlength="items.career.counter"
                        :counter="items.career.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-8"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">資格</span></v-col
              >
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.qual.text"
                      :rules="items.qual.rules"
                    >
                      <v-textarea
                        ref="qual"
                        v-model="cast_prop.qual"
                        name="qual"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.qual.text"
                        rows="4"
                        outlined
                        background-color="white"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-8"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">得意な施術</span></v-col
              >
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.speciality.text"
                      :rules="items.speciality.rules"
                    >
                      <v-text-field
                        ref="speciality"
                        v-model="cast_prop.speciality"
                        name="speciality"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.speciality.text"
                        outlined
                        :maxlength="items.speciality.counter"
                        :counter="items.speciality.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-8"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">セラピストの特徴</span></v-col
              >
              <v-col cols="12" sm="10">
                <ValidationProvider
                  v-slot="{ errors, valid }"
                  :name="items.feature.text"
                  :rules="items.feature.rules"
                >
                  <v-row class="mt-2 mb-2">
                    <v-col
                      v-for="feature in feature_type"
                      :key="feature.value"
                      cols="4"
                      sm="3"
                      md="2"
                    >
                      <v-checkbox
                        class="mt-1"
                        ref="feature"
                        v-model="feature_selected"
                        name="feature"
                        :label="feature.label"
                        :value="feature.value"
                        :success="valid"
                        :error="!valid"
                        hide-details
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-8"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">新人 / PICKUP</span></v-col
              >
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="6">
                    <v-switch
                      class="mt-1"
                      ref="isNew"
                      v-model="cast_prop['new']"
                      name="isNew"
                      :label="items['new'].text"
                    ></v-switch>
                  </v-col>
                  <v-col cols="6">
                    <v-switch
                      class="mt-1"
                      ref="isPickup"
                      v-model="cast_prop['pickup']"
                      name="isPickup"
                      :label="items['pickup'].text"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-8"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">ブログURL</span></v-col
              >
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.blog.text"
                      :rules="items.blog.rules"
                    >
                      <v-text-field
                        ref="blog"
                        v-model="cast_prop.blog"
                        name="blog"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.blog.text"
                        persistent-hint
                        outlined
                        hint="「https://」から入力して下さい"
                        :maxlength="items.blog.counter"
                        :counter="items.blog.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.twitter.text"
                      :rules="items.twitter.rules"
                    >
                      <v-text-field
                        ref="twitter"
                        v-model="cast_prop.twitter"
                        name="twitter"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.twitter.text"
                        persistent-hint
                        outlined
                        hint="URLを入力して下さい。ゴールドプランでのみ表示されます。"
                        :maxlength="items.twitter.counter"
                        :counter="items.twitter.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.instagram.text"
                      :rules="items.instagram.rules"
                    >
                      <v-text-field
                        ref="instagram"
                        v-model="cast_prop.instagram"
                        name="instagram"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.instagram.text"
                        persistent-hint
                        outlined
                        hint="URLを入力して下さい"
                        :maxlength="items.instagram.counter"
                        :counter="items.instagram.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </ValidationObserver>
      </template>
    </only-site-card>
  </div>
</template>

<script>
import { set, reactive, toRefs, defineComponent } from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import store from "@/store/index.js";
import setting from "@/common/setting.js";
import utilFunc from "@/common/utilFunc.js";

export default defineComponent({
  props: ["com_data"],
  setup(props, ctx) {
    const CastPropsRepository = repositoryFactory.get("castProps");
    const state = reactive({
      errorElement: null,
      cast_prop: {},
      // 読み込み時データ保持(保存前比較用)
      keepData: {
        cast_prop: {},
      },
      feature_selected: [],
      feature_type: {
        "feature-id-546": { label: "人気TOP3", value: "546" },
        "feature-id-564": { label: "店長おすすめ", value: "564" },
        "feature-id-556": { label: "要予約", value: "556" },
        "feature-id-555": { label: "プレミア", value: "555" },
        "feature-id-573": { label: "業界未経験", value: "573" },
        "feature-id-582": { label: "経験豊富", value: "582" },
        "feature-id-547": { label: "施術に自信あり", value: "547" },
        "feature-id-551": { label: "モデル系", value: "551" },
        "feature-id-562": { label: "長身系", value: "562" },
        "feature-id-553": { label: "小柄", value: "553" },
        "feature-id-579": { label: "ルックス抜群", value: "579" },
        "feature-id-561": { label: "ハーフ系", value: "561" },
        "feature-id-570": { label: "黒髪美人", value: "570" },
        "feature-id-571": { label: "色白肌", value: "571" },
        "feature-id-577": { label: "キレイ系", value: "577" },
        "feature-id-586": { label: "お姉さん系", value: "586" },
        "feature-id-569": { label: "セクシー系", value: "569" },
        "feature-id-587": { label: "美少女系", value: "587" },
        "feature-id-583": { label: "清楚", value: "583" },
        "feature-id-588": { label: "スタイル抜群", value: "588" },
        "feature-id-554": { label: "アイドル系", value: "554" },
        "feature-id-581": { label: "カワイイ系", value: "581" },
        "feature-id-589": { label: "ギャル系", value: "589" },
        "feature-id-557": { label: "普通", value: "557" },
        "feature-id-578": { label: "癒し系", value: "578" },
        "feature-id-580": { label: "熟女系", value: "580" },
        "feature-id-5796": { label: "人妻系", value: "5796" },
        "feature-id-590": { label: "真面目系", value: "590" },
        "feature-id-563": { label: "努力家", value: "563" },
        "feature-id-572": { label: "礼儀正しい", value: "572" },
        "feature-id-585": { label: "しっかり者", value: "585" },
        "feature-id-576": { label: "オタク", value: "576" },
        "feature-id-549": { label: "ツンデレ", value: "549" },
        "feature-id-550": { label: "アニメ声", value: "550" },
        "feature-id-559": { label: "おしゃべり好き", value: "559" },
        "feature-id-565": { label: "上品", value: "565" },
        "feature-id-566": { label: "明るい", value: "566" },
        "feature-id-567": { label: "空気を読む", value: "567" },
        "feature-id-568": { label: "聞き上手", value: "568" },
        "feature-id-548": { label: "天然", value: "548" },
        "feature-id-558": { label: "恥ずかしがり屋", value: "558" },
        "feature-id-574": { label: "おっとり", value: "574" },
        "feature-id-575": { label: "人懐っこい", value: "575" },
        "feature-id-584": { label: "甘えん坊", value: "584" },
      },
    });

    const items = {
      "comment_1": {
        text: "セラピストからのコメント",
        rules: "",
        counter: "",
      },
      "comment_2": {
        text: "お店からのコメント",
        rules: "",
        counter: "",
      },
      "career": {
        text: "エステ歴",
        rules: "numeric|max:2",
        counter: "2",
      },
      "qual": {
        text: "資格",
        rules: "",
        counter: "",
      },
      "speciality": {
        text: "得意な施術",
        rules: "max:255",
        counter: "255",
      },
      "feature": {
        text: "セラピストの特徴",
        rules: "",
        counter: "",
      },
      "new": {
        text: "このセラピストを新人として表示する",
        rules: "",
        counter: "",
      },
      "pickup": {
        text: "このセラピストをPICKUPとして表示する",
        rules: "",
        counter: "",
      },
      "blog": {
        text: "ブログURL",
        rules: "url|max:255",
        counter: "255",
      },
      "twitter": {
        text: "X(旧Twitter)",
        rules: "url|max:255",
        counter: "255",
      },
      "instagram": {
        text: "Instagram",
        rules: "url|max:255",
        counter: "255",
      },
    };

    // 画面表示用にstate.cast_propの値を整理(媒体コピー処理からreflectCastPropsで呼ばれる)
    const reflectCastProps = async () => {
      state.feature_selected = [];
      // 特徴(JSON配列)を配列に変換
      if (state.cast_prop.feature) {
        state.feature_selected = JSON.parse(state.cast_prop.feature);
      }
    };

    const init = async () => {
      // cast_propにキーを設定
      for (let key in items) {
        set(state.cast_prop, key, null);
      }
      Object.keys(props.com_data.cast_prop).forEach(function (key) {
        if (key == "new" || key == "pickup") {
          set(state.cast_prop, key, props.com_data.cast_prop[key] == "1");
        } else {
          set(state.cast_prop, key, props.com_data.cast_prop[key]);
        }
      });
      // 読み込み時のデータを保持(保存前に比較するため)
      state.keepData.cast_prop = Object.assign({}, state.cast_prop);

      // 画面表示前の後処理
      await reflectCastProps();
    };

    init();

    // チェック処理
    const checkValid = async () => {
      // 事前チェック処理
      state.errorElement = null;
      const isValid = await ctx.refs.observer.validate();
      if (!isValid) {
        let item_name = "";
        Object.keys(ctx.refs.observer.errors).forEach(function (key) {
          if (ctx.refs.observer.errors[key].length > 0) {
            item_name = key;
            return;
          }
        });
        const errorKey = utilFunc.getKeyByItemText(items, item_name);
        if (errorKey == "feature") {
          state.errorElement = ctx.refs[errorKey][0].$el;
        } else {
          state.errorElement = ctx.refs[errorKey].$el;
        }
      }
      return isValid;
    };

    const setErrorFocus = async () => {
      setTimeout(() => {
        state.errorElement.scrollIntoView({
          block: "center",
        });
      }, 300);
    };

    // 保存前にcastPropsの値を整理する(媒体コピー処理からsetCastPropsで呼ばれる)
    const setCastProps = async () => {
      for (let key in state.cast_prop) {
        if (key == "feature") {
          // 特徴 => チェックされた値をJSON配列で格納
          set(
            state.cast_prop,
            key,
            state.feature_selected.length == 0
              ? ""
              : JSON.stringify(state.feature_selected)
          );
        }
      }
    };

    const save = async () => {
      // 保存前にcastPropsの値を整理する
      await setCastProps();

      // 更新前と比べて差分があれば更新処理
      if (!utilFunc.compareObject(state.keepData.cast_prop, state.cast_prop)) {
        const prop_param = [];
        for (let key in state.cast_prop) {
          if (key == "new" || key == "pickup") {
            prop_param.push({
              cast_id: props.com_data.cast_id,
              key: props.com_data.prefix + "__" + key,
              value: state.cast_prop[key] ? "1" : "",
            });
          } else {
            prop_param.push({
              cast_id: props.com_data.cast_id,
              key: props.com_data.prefix + "__" + key,
              value: state.cast_prop[key] ?? "",
            });
          }
        }
        await CastPropsRepository.save_all({ cast_prop: prop_param })
          .then((response) => {
            if (response.data) {
              // データ追加OK
            }
          })
          .catch((error) => {
            throw (
              "ERROR:es_ban.vue/save CastPropsRepository.save_all (" +
              error +
              ")"
            );
          });
      }
      return true;
    };

    return {
      props,
      setting,
      items,
      ...toRefs(state),
      checkValid,
      setErrorFocus,
      save,
      reflectCastProps,
      setCastProps,
    };
  },
});
</script>

<style scoped></style>
